// extracted by mini-css-extract-plugin
export default {"cbtnClass":"cbtn_cbtnClass__gdNJA"};